import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-providers',
  templateUrl: './providers.component.html'
})
export class ProvidersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
